import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { IonicModule } from "@ionic/angular";

import { ExpPageRoutingModule } from "./exp-routing.module";

import { ExpPage } from "./exp.page";
import { SafePipe } from "../pipes/safe.pipe";
import { NgxQRCodeModule } from "@techiediaries/ngx-qrcode";
import { PhonePipe } from "../pipes/phone.pipe";
import { AdjustFontSizePipe } from "../pipes/adjustFontSize.pipe";

@NgModule({
  imports: [CommonModule, NgxQRCodeModule, FormsModule, IonicModule, ExpPageRoutingModule],
  declarations: [ExpPage, SafePipe, PhonePipe, AdjustFontSizePipe],
  exports: [SafePipe, PhonePipe, AdjustFontSizePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ExpPageModule {}
